import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row md:gap-10 md:mx-auto mb-6" }
const _hoisted_2 = { class: "grid grid-cols-2 md:flex md:flex-col gap-4 mb-6" }
const _hoisted_3 = { class: "text-alternative-gray font-semibold text-lg leading-[20px]" }
const _hoisted_4 = { class: "text-brown font-semibold text-lg leading-[20px]" }
const _hoisted_5 = { class: "col-span-2 flex max-md:justify-end" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "bg-white rounded-[20px] p-6 flex flex-col items-start gap-4 md:max-w-[400px]" }
const _hoisted_8 = { class: "font-semibold text-2xl" }
const _hoisted_9 = { class: "w-full flex justify-between gap-2" }
const _hoisted_10 = { class: "text-xs md:text-base md:leading-[20px] text-alternative-gray" }
const _hoisted_11 = { class: "font-semibold text-xl leading-[24px] md:text-2xl text-brown" }
const _hoisted_12 = { class: "font-semibold text-xl leading-[24px]" }
const _hoisted_13 = { class: "w-full grid grid-cols-3 overflow-hidden rounded-lg border border-divider" }


import { QiMenChartResponse } from "@/types/calculators";
import { useI18n } from "vue-i18n";
import GradientButton from "@/components/buttons/GradientButton.vue";

import printer from "@/assets/icons/printer.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'QiMenResults',
  props: {
    qimenChart: {},
    date: {},
    time: {},
    system: {},
    matrixType: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const cellsOrder = [4, 9, 2, 3, 5, 7, 8, 1, 6];
const inputParams = [
  {
    label: "calculators.qi-men.labels.date",
    value: props.date,
    isTranslatable: false,
  },
  {
    label: "calculators.qi-men.labels.time",
    value: props.time,
    isTranslatable: false,
  },
  {
    label: "calculators.qi-men.labels.system",
    value: props.system,
    isTranslatable: true,
  },
  {
    label: "calculators.qi-men.labels.matrix-type",
    value: props.matrixType,
    isTranslatable: true,
  },
];
const dayParams = [
  {
    label: "calculators.qi-men.results.date-pillar",
    value: props.qimenChart.pillar,
  },
  {
    label: "calculators.qi-men.results.structure-type",
    value: props.qimenChart.structure_type,
  },
  {
    label: "calculators.qi-men.results.structure-number",
    value: props.qimenChart.structure_num,
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(inputParams, (inputParam) => {
        return _createElementVNode("div", {
          key: inputParam.label,
          class: "bg-white rounded-[20px] px-4 py-2 flex flex-col gap-2 items-start md:w-[200px] md:h-16"
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)(inputParam.label)), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(inputParam.isTranslatable ? _unref(t)(inputParam.value) : inputParam.value), 1)
        ])
      }), 64)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(GradientButton, {
          class: "w-[125px] h-11 rounded-xl",
          "bg-color": "bg-brown-gradient",
          "hover-bg-color": "bg-orange-gradient",
          text: _unref(t)('buttons.print')
        }, {
          icon: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(printer),
              alt: "Print",
              class: "z-10 mr-2"
            }, null, 8, _hoisted_6)
          ]),
          _: 1
        }, 8, ["text"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)("calculators.qi-men.results.title")), 1),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dayParams, (dayParam) => {
          return _createElementVNode("div", {
            key: dayParam.label,
            class: "border border-ternary rounded-lg flex flex-col gap-2 items-center p-2 flex-1"
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)(dayParam.label)), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(dayParam.value), 1)
          ])
        }), 64))
      ]),
      _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)("calculators.qi-men.results.qi-men-table")), 1),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cellsOrder, (cellIndex) => {
          return _createElementVNode("div", {
            class: _normalizeClass(["flex flex-wrap justify-center h-full aspect-[100/73] border border-divider", cellIndex == 5 ? 'p-4 items-center' : 'pt-[12px] px-[22px]']),
            key: cellIndex
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.qimenChart.chart[cellIndex], (symbol, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: i,
                class: "text-base leading-[20px] md:text-xl md:leading-[24px] text-brown w-1/3 font-normal"
              }, _toDisplayString(symbol), 1))
            }), 128))
          ], 2)
        }), 64))
      ])
    ])
  ]))
}
}

})